import { IOption } from '@shared/models/icommons.model';

/**
 * RemoveFilterEvent interface containing list of removed filters
 * and a flag to determine if at least one of removed filters had
 * a value
 */
export interface RemoveFilterEvent {
  /**
   * list of removed filters
   */
  removedFilters: IOption[];
  /**
   * if at least one of removed filters had a value
   */
  searchRequired: boolean;
}

export enum FilterTypes {
  Equal = 'equal',
  EqualNoCase = 'equalnocase',
  Range = 'range',
  Multi = 'multi',
  Type = 'type',
  MultiField = 'multifield',
  GeoDistance = 'geoDistance',
  GeoPolygon = 'geoPolygon',
  MultiOR = 'multiOR',
  Group = 'group',
  MultiNotEqual = 'multiNotEqual',
  NotExist = 'notExist',
  Prefix = 'match_phrase_prefix',
  Stats = 'stats',
  Period = 'period',
}
